<template>

    <div v-if="show" class="login">

        <main>

            <div class="wh-box">

                <div class="inner">

                    <div v-if="! testHasEnded">
                        <h1>ビジネスキャラ診断<small>サイトエンジン株式会社</small></h1>
                        <h2>注意事項</h2>
                        <ul>
                            <li>通信の良い環境で受診してください。</li>
                            <li>回答の途中でブラウザを閉じたり、戻るボタンや再読み込みボタンを押すなど、他の画面へ遷移しないようにしてください。</li>
                            <li>回答が途中で中断してしまった場合には、診断の再開・やり直しはできません。<br>診断を依頼した担当者へご連絡ください。</li>
                            <li>重複して受診しないようお願いいたします。</li>
                        </ul>
                        <h2>制限時間</h2>
                        <p>{{time}}分</p>
                    </div>

                    <div v-if="testHasEnded && isLoggedIn">
                        <h1>職種適正チェックテスト<small>サイトエンジン株式会社</small></h1>
                    </div>

                    <div v-if="isLoggedIn" class="form-wrap">
                        <form name="loginform" id="loginform" method="post">

                            <div v-if="! testHasEnded" class="action-row">
                                <button
                                    @click="aaaaa"
                                    type="button"
                                    class="active"
                                >診断を開始する</button>
                            </div>
                            <div v-else class="action-row">
                                <button
                                    @click="bbbbb"
                                    type="button"
                                    class="active"
                                >診断結果を見る</button>
                            </div>

                            <div class="action-row">
                                <button
                                    @click="$parent.logout"
                                    type="button"
                                    class="active"
                                >ログアウト</button>
                            </div>

                        </form>
                    </div>

                    <div v-else class="form-wrap">
                        <form @submit.prevent="login">
                            <input
                                v-model="email"
                                id="email"
                                type="email"
                                placeholder="メールアドレス"
                                required
                                autocomplete="off"
                                autofocus
                            >

<!--                            <input-->
<!--                                v-model="password"-->
<!--                                id="password"-->
<!--                                type="password"-->
<!--                                placeholder="パスワード"-->
<!--                                required-->
<!--                                autocomplete="off"-->
<!--                            >-->

                            <div class="submit-wrap">
                                <input type="submit" value="ログイン">
                            </div>
                        </form>
                    </div>

                </div>

            </div>

        </main>

        <Footer />

    </div>

</template>
<style>
.vue-notification {
    padding: 20px !important;
    margin: 15px 15px 0 0 !important;
}
</style>
<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import axios from 'axios'

import {moveToUrl} from '../common'

export default {
    name: "Home",
    components: {
        Header,
        Footer,
    },
    /**
     *
     * @param to
     * @param from
     * @param next
     * @returns {Promise<void>}
     */
    async beforeRouteEnter(to, from, next) {
        console.log('home beforeRouteEnter')

        // エニアグラム受験者でログイン済みであるかチェック
        const employee = await axios.get('/api/enneagram/employee/profile' );

        if (! window.Laravel) window.Laravel = {}
        if (! window.Laravel.employee) window.Laravel.employee = {}

        if (employee.data.id) {
            window.Laravel.isEmployeeLoggedin = true
            window.Laravel.employee.id = employee.data.id
            window.Laravel.employee.name = employee.data.name
            window.Laravel.employee.uuid = employee.data.uuid
        } else {
            window.Laravel.isEmployeeLoggedin = false
            window.Laravel.employee = {}
        }

        next()

    },
    beforeRouteUpdate(to, from, next) {
        console.log('home beforeRouteUpdate')
        next()
    },
    beforeRouteLeave(to, from, next) {
        console.log('home beforeRouteLeave')
        next()
    },
    data() {
        return {
            testHasEnded: false, // 回答済

            num: 0,

            isLoggedIn: false,
            // name: null,

            show: false,

            email: '',
            // password: '',

            time: '',
            base_url:process.env.MIX_APP_BASE_URL
        }
    },
    beforeCreate() {
        console.log('home beforeCreate')
    },
    created() {
        console.log('home created')

        const url = '/api/enneagram/employee/test/' + this.$route.params['id']

        try {
            axios
            .get(url)
            .then(({data:{time}}) => {
                console.log(time)

                this.time = time

                // ログイン済の場合
                if (window.Laravel.isEmployeeLoggedin) {

                    this.isLoggedIn = true

                    //テスト完了済み
                    if (window.Laravel.employee.answer_completed !== undefined
                        && window.Laravel.employee.answer_completed !== null
                        && window.Laravel.employee.answer_completed !== '') {

                        // moveToUrl('/enneagram_test/result/' + window.Laravel.employee.uuid)
                        moveToUrl('/business_character_test/result/' + window.Laravel.employee.uuid)

                    }
                    //テスト未完了
                    else {

                        if (
                            window.Laravel.employee.answer_start !== null &&
                            window.Laravel.employee.answer_start !== '' &&
                            window.Laravel.employee.answer_end !== null &&
                            window.Laravel.employee.answer_end !== ''
                        ) {
                            const now = new Date();
                            const answer_start = new Date(window.Laravel.employee.answer_start);
                            const answer_end = new Date(window.Laravel.employee.answer_end);
                            console.log(now)
                            console.log(answer_end)
                            // 受験時間内
                            if (answer_end > now) {
                                // moveToUrl('/enneagram_test/test/' + this.$route.params['id'])
                                moveToUrl('/business_character_test/test/' + this.$route.params['id'])
                            } else {
                                this.show = true
                            }
                        } else {
                            // moveToUrl('/enneagram_test/test/' + this.$route.params['id'])
                            moveToUrl('/business_character_test/test/' + this.$route.params['id'])
                        }

                    }

                } else {

                    this.show = true
                }


            })
            .catch(error => {
                // window.location.href = window.location.protocol + "//" + window.location.host + "/"
                console.log(error)
            })
        } catch (err) {
            // console.log('11111111')
            console.log(error)
            // // window.location.href = window.location.protocol + "//" + window.location.host + "/login/";
            // window.location.href = window.location.protocol + "//" + window.location.host + "/"
        }
    },
    // beforeMount() {
    //     console.log('home beforeMount')
    // },
    // mounted() {
    //     console.log('home mounted')
    // },
    // beforeUpdate() {
    //     console.log('home beforeUpdate')
    // },
    // updated() {
    //     console.log('home updated')
    // },
    // activated() {
    //     console.log('home activated')
    // },
    // deactivated() {
    //     console.log('home deactivated')
    // },
    // beforeDestroy() {
    //     console.log('home beforeDestroy')
    // },
    // destroyed() {
    //     console.log('home destroyed')
    // },
    // errorCaptured() {
    //     console.log('home errorCaptured')
    // },
    methods: {
        login(event) {
            event.preventDefault()

            // this is managed automatically in the background
            // await this.$axios.$get('/sanctum/csrf-cookie')

            const requestUrl = '/api/enneagram/employee/login'
            const data = {
                // .post('/api/login', {
                uuid: this.$route.params['id'],
                email: this.email,
                // password: this.password
            }
            console.log(requestUrl)
            console.log(data)
            // try {
            axios
            .post(requestUrl, data)
            .then(response => {
                console.log(response)

                // // this.$router.push(window.Laravel.referrer)
                // // // this.$router.go(window.Laravel.referrer)

                // this.isLoggedIn = true

                // // this.$notify({
                // //     text: '<b>ログインしました</b>',
                // //     speed: 1000,
                // //     type: 'success', // success、info、warn、error
                // //     // duration: -1,
                // // })
// return
                this.show = false

                // window.location.href = window.base_url + '/' + this.$route.params['id']
                // moveToUrl('/enneagram_test/' + this.$route.params['id'])
                moveToUrl('/business_character_test/' + this.$route.params['id'])

            })
            .catch(error => {
                console.log(error)
                // console.log('error.message : ' + error.message)
                // console.log('error.response.stat : ' + error.response.status)
                // console.log('error.response.statusText : ' + error.response.statusText)
                // console.log('error.response.data.errors : ' + error.response.data.errors)
                // console.log('error.response.data.message : ' + error.response.data.message)

                // error.message                Request failed with status code 419
                // error.response.status        419
                // error.response.statusText    unknown status
                // error.response.data.errors   undefined
                // error.response.data.message  CSRF token mismatch.

                if (error.response.status === 419) {

                    // // this.$router.push('/login')
                    // window.location.href = '/login'

                    window.location.href = window.base_url + '/' + this.$route.params['id']

                } else {


                    this.$notify({
                        text: '<b>' + error.response.data.message + '</b>',
                        speed: 1000,
                        type: 'error', // success、info、warn、error
                        // duration: -1,
                    })

                }
            })
            // } catch (error) {
            //     // this.error = error.response.data.message
            //     console.log(error)
            // }
        },
        aaaaa(event) {
            console.log('AAAAA')
            if (! this.testHasEnded) {
                // this.$router.push('/enneagram_test/test/' + this.$route.params['id'])
                // window.location.href = '/enneagram_test/test/' + this.$route.params['id']
                window.location.href = '/business_character_test/test/' + this.$route.params['id']
            }
        },
        bbbbb(event) {
            console.log('BBBBB')
            window.profile('employee').then((response) => {
                // 未ログインの場合
                if (! window.Laravel.isEmployeeLoggedin) {
                    window.location.href = window.base_url
                } else {
                    window.Laravel.employee = response.data
                    // console.log(response.data.answer_completed)
                    // console.log(window.Laravel.employee.answer_completed)
                    if (window.Laravel.employee.answer_completed !== null && window.Laravel.employee.answer_completed !== '') {
                        // this.testHasEnded = true;
                        // this.$router.push('/result')
                        // window.location.href = '/result'

                        // window.open('/result')

                        // const newwin = open(window.base_url + '/result');
                        window.location.href = window.base_url + '/result/' + window.Laravel.employee.uuid

                        // setTimeout(() => {
                        //     newwin.close();
                        // }, 2000)
                    } else {
                        // this.testHasEnded = false;
                        window.location.href = window.base_url
                    }
                }
            })
        },
    },
}
</script>
